import { createIcon } from './createIcon'

export const EyeIcon = createIcon({
  displayName: 'Eye',
  viewBox: '0 0 20 21',
  path: [
    <path
      d="M11.7678 12.0839C12.2366 11.6151 12.5 10.9792 12.5 10.3162C12.5 9.65312 12.2366 9.01724 11.7678 8.54839C11.2989 8.07955 10.663 7.81616 10 7.81616C9.33696 7.81616 8.70107 8.07955 8.23223 8.54839C7.76339 9.01724 7.5 9.65312 7.5 10.3162C7.5 10.9792 7.76339 11.6151 8.23223 12.0839C8.70107 12.5528 9.33696 12.8162 10 12.8162C10.663 12.8162 11.2989 12.5528 11.7678 12.0839Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M2.04834 10.3161C3.11001 6.93529 6.26917 4.48279 10 4.48279C13.7317 4.48279 16.89 6.93529 17.9517 10.3161C16.89 13.697 13.7317 16.1495 10 16.1495C6.26917 16.1495 3.11001 13.697 2.04834 10.3161Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
})
